import React from 'react';
import '../../styles/demokratiuka-fonts.css';
import '@fontsource/be-vietnam-pro/400.css';
import '@fontsource/be-vietnam-pro/500.css';
import '@fontsource/be-vietnam-pro/600.css';
import '@fontsource/be-vietnam-pro/700.css';
import { DEMOKRATIUKA_COLORS, DEMOKRATIUKA_FONT } from '../../lib/demokratiukaBrand';

interface Props {
  children: React.ReactNode;
}

export const DemokratiukaLayout: React.FC<Props> = ({ children }) => {
  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: '#ffffff',
        fontFamily: DEMOKRATIUKA_FONT,
        WebkitFontSmoothing: 'antialiased',
        color: '#000000',
      }}
    >
      {/* Header — Ytringsfrihet-blå med D-symbol og ordmerke */}
      <header
        className="px-4 sm:px-6 py-4 sm:py-5"
        style={{ backgroundColor: DEMOKRATIUKA_COLORS.ytringsfrihet }}
      >
        <div className="max-w-[1440px] mx-auto flex items-center gap-3">
          <svg
            viewBox="0 0 30.05 30.05"
            style={{ height: '28px', width: '28px', color: '#ffffff' }}
            aria-hidden="true"
          >
            <path d="M15.025,0V30.049a15.025,15.025,0,0,0,15.025-15.025h0A15.025,15.025,0,0,0,15.025,0Z" fill="currentColor" />
            <path d="M0,0V7.512a7.512,7.512,0,0,0,15.025,0V0Z" fill="currentColor" />
            <path d="M0,30.05H7.512a7.512,7.512,0,1,0,0-15.025H0Z" fill="currentColor" />
          </svg>
          <span
            style={{
              color: '#ffffff',
              fontSize: '1.125rem',
              fontWeight: 700,
              letterSpacing: '-0.01em',
            }}
          >
            Demokratiuka
          </span>
        </div>
      </header>

      {/* Innhold */}
      <main className="px-4 sm:px-6 py-8 sm:py-12 max-w-[720px] mx-auto">
        {children}
      </main>
    </div>
  );
};
